export default __webpack_public_path__ + "static/media/vehicle.95063d4d61e111ba0970fb67a2186719.svg";